export default __webpack_public_path__ + "static/media/Background_00002.c8732686.png";